module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_green_en.6f006d19.png";